module.exports = __webpack_public_path__ + "static/media/icon-vie-creche-white.9e910aee.svg";